// extracted by mini-css-extract-plugin
module.exports = {"StockLatestNews":"StockLatestNews_StockLatestNews__SmMpu","more":"StockLatestNews_more__gxWmb"};